import { render, staticRenderFns } from "./setPushDialog.vue?vue&type=template&id=7b1569ad&scoped=true"
import script from "./setPushDialog.vue?vue&type=script&lang=ts"
export * from "./setPushDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1569ad",
  null
  
)

export default component.exports